<template>
  <div class="fixturesTableBox">
    <div class="data-loading" style="padding: 15% 0 20% 0" v-if="logdingFlag()">
      <van-loading vertical>{{ langConfig.txtLang[langConfig.curLang]['LOADING'] }}</van-loading>
    </div>
    <div v-else>
      <template v-if="originMatchList.length">
        <div class="head flex flex-align-center flex-pack-justify">
          <div class="orderType flex">
            <div class="title">{{ langConfig.leagues[langConfig.curLang]['ORDER'] }}</div>
            <div
              v-for="(item, index) in orderOptions"
              :key="item.value"
              @click="changeType(item.value)"
              :class="[
                'orderType_' + (index + 1),
                item.value == order ? 'active' : '',
              ]"
            >
              {{ item.label }}
            </div>
            <div
              class="mOrderType flex flex-align-center"
              @click="showOrderPopup = true"
            >
              <span>{{
                orderOptions.find((item) => item.value == order)["label"]
              }}</span
              ><i class="icon-font icon-arr"></i>
            </div>
          </div>
          <div class="operation flex flex-align-center flex-pack-center">
            <i class="icon-font icon-arr unfold" @click="unfold"></i>
            <i class="icon-font icon-arr fold" @click="fold"></i>
            <i
              class="icon-font icon-filter filter"
              :class="
                roundSelected.length != roundList.length ? 'selected' : ''
              "
              @click="$refs.optionsPopup.showPopup()"
              >{{ langConfig.leagues[langConfig.curLang]['OPTIONAL'] }}</i
            >
          </div>
        </div>
        <!-- order弹窗 -->
        <van-popup
          v-model="showOrderPopup"
          position="bottom"
          :style="{
            backgroundColor: '#F5F5F5',
            borderTopLeftRadius: '0.2rem',
            borderTopRightRadius: '0.2rem',
          }"
          get-container="#app"
        >
          <div class="mOrderWarp" v-if="showOrderPopup">
            <ul class="mOrderList">
              <li
                v-for="item in orderOptions"
                :key="item.value"
                :class="item.value == order ? 'active' : ''"
                @click="
                  changeType(item.value);
                  showOrderPopup = false;
                "
              >
                {{ item.label }}
              </li>
            </ul>
            <div class="cancel" @click="showOrderPopup = false">Cancel</div>
          </div>
        </van-popup>
        <!-- round筛选 -->
        <OptionsFilter
          ref="optionsPopup"
          :options="roundList"
          :roundSelected="roundSelected"
          @optionsSelectedChange="optionsSelectedChange"
        />
        <div class="fixturesWarp">
          <div
            class="fixtures"
            :class="on.includes(index) ? 'on' : ''"
            v-for="(round, index) in order == 'time'
              ? timeMatchList
              : stageMatchList"
            :key="order == 'time' ? round.time : round.run + round.group"
            v-show="
              order == 'time'
                ? round.matchList.reduce(
                    (t, v) => t + roundSelected.includes(v.run),
                    0
                  )
                : roundSelected.includes(round.run)
            "
          >
            <div
              class="fixtures-header flex flex-pack-justify"
              @click="rowClick(index)"
            >
              <div class="round">
                {{
                  order == "time"
                    ? getGameTime(round.startTime)
                    : round.run + " " + round.group
                }}
              </div>
              <div class="tips" v-show="!on.includes(index)">
                {{ langConfig.index[langConfig.curLang]['DISPLAY_MATCHES'] }}
              </div>
            </div>
            <div class="fixtures-match-list" v-show="on.includes(index)">
              <div
                :id="'match_id_' + item.matchId"
                class="fixtures-match-item"
                v-for="item in round.matchList"
                :key="item.matchId"
                v-show="
                  order == 'time' ? roundSelected.includes(item.run) : true
                "
                @click.stop="toInsidePage(item.state, item.matchId, item.homeTeam.fullName, item.awayTeam.fullName)"
              >
                <div
                  class="fixtures-stage"
                  :class="
                    [1, 2, 3, 5, 10, 11, 16].includes(item.state) ? 'ing' : ''
                  "
                >
                  <span
                    class="fixtures-stage-block"
                    v-html="gameTime(item.state, item.startTime)"
                  ></span>
                </div>
                <div class="fixtures-logo-home">
                  <img
                    :src="common.teamImgGet(item['homeTeam']['id'])"
                    @error="common.imgError($event, 'team')"
                  />
                </div>
                <div
                  class="team-name-home"
                  :class="
                    item['homeLive']['scoreFull'] >
                      item['awayLive']['scoreFull'] && item.state == 4
                      ? 'win'
                      : ''
                  "
                >
                  {{ item["homeTeam"]["fullName"] }}
                  <i
                    class="redCard-icon"
                    v-if="isItem(item['homeLive'], 'redCard')"
                    >{{ item["homeLive"]["redCard"] }}</i
                  >
                </div>
                <div class="fixtures-logo-away">
                  <img
                    :src="common.teamImgGet(item['awayTeam']['id'])"
                    @error="common.imgError($event, 'team')"
                  />
                </div>
                <div
                  class="team-name-away"
                  :class="
                    item['awayLive']['scoreFull'] >
                      item['homeLive']['scoreFull'] && item.state == 4
                      ? 'win'
                      : ''
                  "
                >
                  {{ item["awayTeam"]["fullName"] }}
                  <i
                    class="redCard-icon"
                    v-if="isItem(item['awayLive'], 'redCard')"
                    >{{ item["awayLive"]["redCard"] }}</i
                  >
                </div>
                <div
                  class="fixtures-score-home"
                  :class="
                    [1, 2, 3, 5, 10, 11, 16].includes(item.state) ? 'ing' : ''
                  "
                >
                  {{ scoreCallFn(item.state, item["homeLive"], "scoreFull") }}
                </div>
                <div
                  class="fixtures-score-away"
                  :class="
                    [1, 2, 3, 5, 10, 11, 16].includes(item.state) ? 'ing' : ''
                  "
                >
                  {{ scoreCallFn(item.state, item["awayLive"], "scoreFull") }}
                </div>
                <div class="fixtures-part-home">
                  <span v-if="item.state == 4">
                    （{{
                      scoreCallFn(item.state, item["homeLive"], "scoreHalf")
                    }}）
                  </span>
                </div>
                <div class="fixtures-part-away">
                  <span v-if="item.state == 4"
                    >（{{
                      scoreCallFn(item.state, item["awayLive"], "scoreHalf")
                    }}）</span
                  >
                </div>
                <div class="fixtures-corner-home">
                  <template
                    v-if="scoreCallFn(item.state, item['homeLive'], 'corner')"
                  >
                    <img
                      src="~@/assets/images/corner-icon.svg"
                      alt="SVG Image"
                      class="corner-icon"
                    /><span>{{
                      scoreCallFn(item.state, item["homeLive"], "corner")
                    }}</span>
                  </template>
                </div>
                <div class="fixtures-corner-away">
                  <template
                    v-if="scoreCallFn(item.state, item['awayLive'], 'corner')"
                  >
                    <img
                      src="~@/assets/images/corner-icon.svg"
                      alt="SVG Image"
                      class="corner-icon"
                    /><span>{{
                      scoreCallFn(item.state, item["awayLive"], "corner")
                    }}</span>
                  </template>
                </div>
                <div class="fixtures-fav">
                  <button
                    type="button"
                    class="icon-font event-fav"
                    :class="follow[item.matchId] ? 'event-fav-selected' : ''"
                    @click.stop="followMatch(item.state, item.matchId)"
                    v-if="!isAfter7Days(item.startTime)"
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else><DefaultPic /></template>
    </div>
  </div>
</template>
<script>
import OptionsFilter from "./optionsFilter";
import DefaultPic from "@/components/defaultPic";
import { getFixturesData } from "@/api/api";
export default {
  props: ["params", "setting"],
  components: {
    OptionsFilter,
    DefaultPic,
  },
  data() {
    return {
      loading: true,
      league: {
        leagueId: null,
        season: "",
      },
      type: "Tournament Phases",
      order: "stage",
      orderOptions: [
        { label: this.langConfig.leagues[this.langConfig.curLang]['TOURNAMENT_PHASES'], value: "stage" },
        { label: this.langConfig.leagues[this.langConfig.curLang]['START_TIME'], value: "time" },
      ],
      roundSelected: [],
      roundList: [],
      originMatchList: [],
      stageMatchList: [],
      timeMatchList: [],
      showOrderPopup: false,
      showOptionsPopup: false,
      on: [],
      follow: {},
    };
  },
  mounted() {
    if (
      typeof localStorage != "undefined" &&
      localStorage.getItem("leagues-fixtures-order") != null
    ) {
      this.order = localStorage.getItem("leagues-fixtures-order");
    }
  },
  methods: {
    logdingFlag() {
      if (typeof window != "undefined" && this.loading) {
        return true;
      }
      return false;
    },
    async loadFixturesData() {
      let userToken = "";
      let _userInfo = this.common.getCookie("userInfo");
      if (_userInfo != null) {
        _userInfo = JSON.parse(_userInfo) || {};
        if ("token" in _userInfo) {
          userToken = _userInfo["token"];
        }
      }
      const { leagueId, season } = this.params;
      const response = await getFixturesData({
        leagueId,
        season,
        userToken,
      });
      this.loading = false;
      if (response.state === 200) {
        const _data = response.data;
        // console.log("getFixturesData", JSON.parse(JSON.stringify(_data)));
        const matchList = _data["match"] || [];
        const round = _data["allRun"] || [];
        const followMatch = _data["followMatch"] || {};
        this.follow = followMatch;
        this.roundSelected = round;
        this.roundList = round;
        this.originMatchList = matchList;
        this.stageMatchList = matchList;
        // 时间范围排序
        this.timeOrderFormat();
        // console.log("timeObject", this.timeMatchList);
      }
    },
    timeOrderFormat() {
      const matchList = this.originMatchList;
      const timeObject = {};
      matchList.forEach((round) => {
        round?.matchList?.forEach((match) => {
          const date = this.getGameTime(match.startTime);
          if (timeObject[date]) {
            timeObject[date]["matchList"].push({ ...match, run: round.run });
          } else {
            timeObject[date] = {
              startTime: match.startTime,
              matchList: [{ ...match, run: round.run }],
            };
          }
        });
      });
      this.timeMatchList = Object.values(timeObject).sort(
        (a, b) => a.startTime - b.startTime
      );
      this.on = (this.order == "time" ? this.timeMatchList : matchList).map(
        (item, index) => index
      );
      // 定位比赛
      // this.location();
    },
    // 是否7天后的比赛
    isAfter7Days(startTime) {
      const startDate = new Date(startTime * 1000);
      startDate.setDate(startDate.getDate() - 7); // 7天后
      const currentDate = new Date();
      return startDate > currentDate;
    },
    // 定位
    location() {
      if (this.$route.params?.tab != 2) return;
      const orginData = this.originMatchList;
      const matchList = this.timeMatchList
        .map((item) => item?.matchList || [])
        .flat();

      // 未开始比赛ID
      let positionMatchID = 0; // 定位比赛ID
      let finishedCount = 0; // 完场场数
      let totalCount = 0; // 总条数
      matchList.forEach((match) => {
        totalCount++;
        if (match.state == 4) finishedCount++;
      });
      const notStartMatchId =
        matchList.find((item) => item.state == 17)?.["matchId"] || 0;

      let lastMatchId = 0;
      if (this.order == "time") {
        lastMatchId = matchList?.[matchList.length - 1]?.["matchId"] || 0;
      } else {
        lastMatchId =
          orginData?.[orginData.length - 1]?.["matchList"]?.[
            orginData?.[orginData.length - 1]?.["matchList"].length - 1
          ]?.["matchId"];
      }
      positionMatchID = notStartMatchId;
      if (finishedCount == totalCount) positionMatchID = lastMatchId;
      if (positionMatchID != 0) {
        this.$nextTick(() => {
          const $target = document.querySelector(
            `#match_id_${positionMatchID}`
          );
          if ($target != null) {
            const rect = $target.getBoundingClientRect();
            const scrollTop = rect.top + window.pageYOffset;
            document.documentElement.scrollTop = scrollTop;
          }
        });
      }
    },
    // 是否有数据返回
    isItem(item, key) {
      if (typeof item != "undefined" && key in item && item[key]) {
        return true;
      }
      return false;
    },
    // 日期转换-时区
    getGameTime(startTime, format = "dd/MM/YYYY") {
      var _tz = "+08:00";
      var _this = this;
      var setting = _this.common.getCookie("setting");

      if (setting != null && setting != undefined && setting) {
        setting = JSON.parse(setting);
        _tz = setting.tsz;
      }

      if(this.langConfig.curLang == 'kr' && format == "dd/MM/YYYY"){
        format = "YYYY-MM-dd"
      }

      var _time = this.common.dateStr(
        this.common.getDateByArray(_tz, startTime),
        format
      );

      return _time;
    },
    // 进程时间
    gameTime(state, time) {
      if ([1, 2, 3, 5, 6, 8, 10, 11, 13, 17].indexOf(state) > -1) {
        //未开赛
        if (this.order == "time") return this.getGameTime(time, "HH:mm");
        else
          return this.getGameTime(time, "dd/MM HH:mm").replace(" ", "<br />");
      } else {
        //其它状态
        return this.langConfig.txtLang[this.langConfig.curLang]["STATE_ARR"][
          state
        ];
      }
    },
    // 比分返回
    scoreCallFn(state, item, key) {
      if ([4].includes(state)) {
        return item[key] || 0;
      } else {
        return "";
      }
    },
    // 折叠
    fold() {
      // 折叠
      this.on = [];
    },
    // 展开
    unfold() {
      // 展开
      this.on = (
        this.order == "time" ? this.timeMatchList : this.stageMatchList
      ).map((item, index) => index);
    },
    rowClick(index) {
      if (this.on.includes(index))
        this.on = this.on.filter((item) => item != index);
      else this.on.push(index);
    },
    // 比赛关注
    followMatch(state, matchId) {
      let _state = +state,
        _matchId = matchId,
        _follow = this.follow;
      if ([4, 5, 6, 13, 14, 15].includes(_state)) {
        return;
      } else {
        let _param = {
          matchId: _matchId,
          operation: 1,
        };

        if (_follow[_matchId]) {
          _param.operation = 2;
        }

        _param.callback = (res) => {
          if (res.state == 403) {
            // 未登录
            this.$emit("onChangLogin", {
              loginShow: true,
            });
          }
          if (res.state == 200) {
            if (typeof _follow[_matchId] == "undefined") {
              _follow[_matchId] = false;
            }

            if (_param.operation == 2) {
              _follow[_matchId] = false;
              this.$message({
                dangerouslyUseHTMLString: true,
                message: "<div><span>Removed from My Favorites.</span></div>",
                type: "success",
                iconClass: "icon-font event-fav favDelIcon",
                customClass: "favSuccess",
                //offset: (document.documentElement.clientHeight - 50),
                duration: 5000,
              });
            } else {
              _follow[_matchId] = true;
              this.$message({
                dangerouslyUseHTMLString: true,
                message:
                  '<div class="flex flex-align-center"><a href="/favorites" class="flex flex-align-center favPop"><span>Added to My Favorites.</span><i class="icon-font icon-arr favArr"></i></a></div>',
                type: "success",
                iconClass: "icon-font icon-collectStar favSuccessIcon",
                customClass: "favSuccess",
                //offset: (document.documentElement.clientHeight - 50),
                duration: 5000,
              });
            }
            this.follow = _follow;
            this.$forceUpdate();
          }
        };

        this.common.followMatch(_param);
      }
    },
    // order类型切换
    changeType(type) {
      this.order = type;
      localStorage.setItem("leagues-fixtures-order", type);
      if (type == "stage") {
        this.on = this.stageMatchList.map((item, index) => index);
      }
      if (type == "time") {
        this.on = this.timeMatchList.map((item, index) => index);
      }
      // 定位比赛
      // this.location();
    },
    // 轮次筛选
    optionsSelectedChange(values) {
      this.roundSelected = values;
      this.on = (
        this.order == "time" ? this.timeMatchList : this.stageMatchList
      ).map((item, index) => index);
    },
    // 跳转比赛内页
    toInsidePage(state, matchId, homeTeam, awayTeam) {
      let tab = "";
      if ([1, 2, 3, 4, 5, 10, 11, 16].includes(state)) {
        tab = "Summary";
      } else {
        tab = "H2H";
      }
      this.$router.push(`/details/${matchId}/${this.common.formalTitle(homeTeam)}-vs-${this.common.formalTitle(awayTeam)}/${tab}`);
    },
  },
  watch: {
    params: {
      deep: true,
      handler(value) {
        if (JSON.stringify(value) != JSON.stringify(this.league)) {
          if (value["leagueId"]) {
            this.league = value;
            this.loadFixturesData();
          }
        }
      },
    },
    setting: {
      deep: true,
      handler(value) {
        this.timeOrderFormat();
      },
    },
    "$route.params.tab": {
      handler(value) {
        // if (value == 2) this.location();
      },
    },
  },
};
</script>
<style lang="less">
.fixturesTableBox {
  background: @color_FFF;
  padding: 16px 8px 48px 8px;
  .head {
    margin-bottom: 16px;
    .orderType {
      font-family: @font_family_SF_Pro_Display;
      color: @color_434343;
      font-size: 14px;
      line-height: 24px;
      .title {
        padding: 0 8px;
      }
      .orderType_1 {
        padding: 0 8px;
        border-radius: 4px 0px 0px 4px;
        border: 1px solid @color_BFBFBF;
        cursor: pointer;
      }
      .orderType_1.active {
        background: @color_FF6915;
        color: @color_FFF;
        border: 1px solid @color_FF6915;
      }
      .orderType_2 {
        padding: 0 8px;
        border-radius: 0px 4px 4px 0px;
        border: 1px solid @color_BFBFBF;
        cursor: pointer;
      }
      .orderType_2.active {
        background: @color_FF6915;
        color: @color_FFF;
        border: 1px solid @color_FF6915;
      }
    }
    .mOrderType {
      display: none;
    }
    .operation {
      i {
        width: 24px;
        height: 24px;
        line-height: 24px;
        border: 1px solid @color_434343;
        text-align: center;
        border-radius: 4px;
        margin-left: 8px;
        cursor: pointer;
        &.unfold {
          transform: rotate(180deg);
        }
        &.filter {
          width: auto;
          padding: 0 8px 0 4px;
          font-size: 14px;
          position: relative;
          &.selected {
            &::after {
              content: "";
              position: absolute;
              right: -5px;
              top: -5px;
              width: 10px;
              height: 10px;
              background-color: @color_E8503A;
              border-radius: 50%;
            }
          }
        }
      }
    }
  }

  .fixturesWarp {
    .fixtures {
      position: relative;
      &::after {
        content: "";
        position: absolute;
        right: 8px;
        top: 6px;
        width: 20px;
        height: 20px;
        background: url("../../../assets/images/icon-down.png") 0 0 / contain
          no-repeat;
      }
      &:not(:last-child) {
        margin-bottom: 8px;
      }
      &.on {
        &::after {
          background: url("../../../assets/images/icon-up.png") 0 0 / contain
            no-repeat;
        }
        .fixtures-table {
          display: table;
        }
      }
      .fixtures-header {
        background-color: #f0f0f0;
        height: 30px;
        line-height: 30px;
        padding: 0 36px 0 8px;
        font-size: 14px;
        cursor: pointer;
      }
      .fixtures-match-list {
        .fixtures-match-item {
          display: grid;
          grid-template-areas: "stageOrTime homeLogo homeTeamName homeScore homePart homeCorner favBtn" "stageOrTime awayLogo awayTeamName awayScore awayPart awayCorner favBtn";
          grid-template-columns: 72px 28px 1fr 24px 24px 50px 50px;
          grid-auto-flow: column;
          justify-content: flex-start;
          position: relative;
          font-family: @font_family_SF_Pro_Display;
          font-size: 14px;
          border-bottom: 1px solid @color_F0F0F0;
          padding: 8px 0;
          cursor: pointer;
          &:hover {
            background-color: @color_FFF7F2;
          }
          .fixtures-stage {
            grid-area: stageOrTime;
            color: @color_434343;
            &.ing {
              color: @color_FF6915;
            }
          }
          .fixtures-logo-home {
            grid-area: homeLogo;
          }
          .team-name-home {
            grid-area: homeTeamName;
          }
          .fixtures-logo-away {
            grid-area: awayLogo;
          }
          .team-name-away {
            grid-area: awayTeamName;
          }
          .fixtures-score-home {
            grid-area: homeScore;
          }
          .fixtures-score-away {
            grid-area: awayScore;
          }
          .fixtures-part-home {
            grid-area: homePart;
          }
          .fixtures-part-away {
            grid-area: awayPart;
          }
          .fixtures-corner-home {
            grid-area: homeCorner;
          }
          .fixtures-corner-away {
            grid-area: awayCorner;
          }
          .fixtures-fav {
            grid-area: favBtn;
          }
          .fixtures-stage,
          .fixtures-logo-home,
          .team-name-home,
          .fixtures-logo-away,
          .team-name-away,
          .fixtures-score-home,
          .fixtures-score-away,
          .fixtures-part-home,
          .fixtures-part-away,
          .fixtures-corner-home,
          .fixtures-corner-away,
          .fixtures-fav {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .fixtures-fav {
            justify-content: flex-end;
          }
          .fixtures-part-home,
          .fixtures-part-away,
          .fixtures-corner-home,
          .fixtures-corner-away {
            color: @color_8C8C8C;
          }
          .fixtures-score-home,
          .fixtures-score-away {
            font-size: 16px;
            &.ing {
              color: @color_FF6915;
            }
          }
          .fixtures-logo-home,
          .fixtures-logo-away {
            margin-right: 8px;
            img {
              width: 20px;
            }
          }
          .team-name-home,
          .team-name-away {
            line-height: 28px;
            justify-content: flex-start;
            color: @color_000;
            &.win {
              font-weight: bold;
            }
          }
          .fixtures-corner-home,
          .fixtures-corner-away {
            justify-content: flex-start;
            padding-left: 16px;
            .corner-icon {
              width: 14px;
              margin-right: 4px;
            }
          }
          .redCard-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 20px;
            padding: 0 4px;
            margin-left: 8px;
            color: @color_FFF;
            font-size: 12px;
            font-family: @font_family_SF_Pro_Display;
            border-radius: 3px;
            background-color: @color_E8503A;
          }
          .event-fav {
            margin: 0 0.08rem;
            color:@color_8C8C8C;
            font-size:22px;
            border:0;
            background-color: transparent;
            cursor:pointer;
            &:before {
                content: "\e644";
            }
            &.event-fav-selected {
              color: @color_FFB23F;
              &:before {
                  content: "\e643";
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .fixturesTableBox {
    width: 100%;
    padding: 0.1rem 0 0.4rem;
    .head {
      width: 100%;
      padding: 0 0.12rem;
      margin-bottom: 0.1rem;
      .orderType {
        font-size: 0.14rem;
        line-height: 0.2rem;
        .title {
          padding: 0;
          padding-right: 0.08rem;
        }
        .orderType_1,
        .orderType_2 {
          display: none;
        }
      }
      .mOrderType {
        display: block;
        padding: 0 0.04rem 0 0.08rem;
        border: 1px solid @color_BFBFBF;
        border-radius: 0.04rem;
        span {
          font-size: 0.12rem;
          color: @color_434343;
        }
        i {
          transform: rotate(180deg);
          display: inline-block;
        }
      }
      .operation {
        i {
          width: 0.2rem;
          height: 0.2rem;
          line-height: 0.2rem;
          border-radius: 0.04rem;
          margin-left: 0.08rem;
          font-size: 0.14rem;
          &.filter {
            padding: 0 0.08 0 0.04rem;
            font-size: 0.12rem;
            &.selected {
              &::after {
                right: -0.04rem;
                top: -0.04rem;
                width: 0.08rem;
                height: 0.08rem;
              }
            }
          }
        }
      }
    }

    .fixturesWarp {
      width: 100%;
      .fixtures {
        &::after {
          right: 0.08rem;
          top: 0.05rem;
          width: 0.2rem;
        }
        &:not(:last-child) {
          margin-bottom: 0.04rem;
        }
        .fixtures-header {
          height: 0.3rem;
          line-height: 0.3rem;
          padding: 0 0.36rem 0 0.08rem;
          font-size: 0.14rem;
        }
        .fixtures-match-list {
          .fixtures-match-item {
            grid-template-columns: 0.72rem 0.28rem 1fr 0.24rem 0.24rem 0.5rem 0.5rem;
            font-size: 0.14rem;
            padding: 0.12rem 0;
            .fixtures-logo-home,
            .fixtures-logo-away {
              margin-right: 0.08rem;
              img {
                width: 0.2rem;
                margin: 0.03rem 0;
              }
            }
            .team-name-home,
            .team-name-away {
              line-height: 0.2rem;
            }
            .fixtures-corner-home,
            .fixtures-corner-away {
              padding-left: 0.1rem;
              .corner-icon {
                width: 0.14rem;
                margin-right: 0.04rem;
              }
            }
            .redCard-icon {
              height: 0.16rem;
              padding: 0 0.03rem;
              margin-left: 0.08rem;
              font-size: 0.12rem;
              border-radius: 0.02rem;
            }
          }
        }
      }
    }
  }

  .mOrderWarp {
    .mOrderList {
      background-color: #fff;
      li {
        height: 0.48rem;
        line-height: 0.48rem;
        font-size: 0.16rem;
        color: #434343;
        text-align: center;
        &:not(:last-child) {
          border-bottom: 1px solid #f0f0f0;
        }
        &.active {
          color: @color_FF6915;
          font-weight: 700;
        }
      }
    }
    .cancel {
      color: #8c8c8c;
      background-color: #fff;
      height: 0.48rem;
      line-height: 0.48rem;
      text-align: center;
      margin-top: 0.06rem;
      font-size: 0.16rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// ./src/views/leagues/components/fixturesTable.vue